var map = {
	"./basic/assets/config": 97976,
	"./basic/assets/config/": 97976,
	"./basic/assets/config/index": 97976,
	"./basic/assets/config/index.js": 97976,
	"./basic/assets/html/CHSU_UAT_HTML5_MiniQW_package.html": 29341,
	"./basic/assets/images/backgrounds/login_bg.png": 31145,
	"./basic/assets/images/logo/logo.ico": 67249,
	"./basic/assets/images/logo/logo_dark.png": 91344,
	"./basic/assets/images/logo/logo_light.png": 46034,
	"./basic/assets/languages/cn.json": 4868,
	"./basic/assets/languages/en.json": 4478,
	"./basic/assets/languages/hk.json": 23596,
	"./basic/assets/languages/vi.json": 504,
	"./basic/assets/styles/components/copy-right/copy-right.scss": 35952,
	"./basic/assets/styles/components/security-tips/security-tips.scss": 76186,
	"./basic/components/Authentication/ImportantNotes/ImportantNotesDialog": 64982,
	"./basic/components/Authentication/ImportantNotes/ImportantNotesDialog.js": 64982,
	"./basic/components/CopyRight/CopyRight": 73287,
	"./basic/components/CopyRight/CopyRight.js": 73287,
	"./basic/configurations/app-configs/config": 72663,
	"./basic/configurations/app-configs/config.js": 72663,
	"./cmbi/assets/config": 82529,
	"./cmbi/assets/config/": 82529,
	"./cmbi/assets/config/index": 82529,
	"./cmbi/assets/config/index.js": 82529,
	"./cmbi/assets/images/backgrounds/login_bg.png": 35784,
	"./cmbi/assets/images/logo/logo.ico": 15290,
	"./cmbi/assets/images/logo/logo.png": 18900,
	"./cmbi/assets/images/logo/logo_dark.png": 27669,
	"./cmbi/assets/images/logo/logo_light.png": 74010,
	"./cmbi/assets/languages/cn.json": 643,
	"./cmbi/assets/languages/en.json": 58073,
	"./cmbi/assets/languages/hk.json": 14459,
	"./cmbi/assets/languages/vi.json": 40907,
	"./cmbi/components/Authentication/ImportantNotes/ImportantNotesDialog": 10891,
	"./cmbi/components/Authentication/ImportantNotes/ImportantNotesDialog.js": 10891,
	"./cmbi/components/CopyRight/CopyRight": 30640,
	"./cmbi/components/CopyRight/CopyRight.js": 30640,
	"./cmbi/configurations/app-configs/config": 76830,
	"./cmbi/configurations/app-configs/config.js": 76830,
	"./eif/assets/config": 93046,
	"./eif/assets/config/": 93046,
	"./eif/assets/config/index": 93046,
	"./eif/assets/config/index.js": 93046,
	"./eif/assets/config/mdsInfo.prod": 83537,
	"./eif/assets/config/mdsInfo.prod.js": 83537,
	"./eif/assets/config/mdsInfo.uat": 42936,
	"./eif/assets/config/mdsInfo.uat.js": 42936,
	"./eif/assets/html/CHSU_UAT_HTML5_MiniQW_package.html": 50295,
	"./eif/assets/html/Important_Notice_English.html": 68809,
	"./eif/assets/html/Important_Notice_Simplified.html": 40495,
	"./eif/assets/html/Important_Notice_Traditional.html": 66668,
	"./eif/assets/html/Ip_Restricted_English.html": 9089,
	"./eif/assets/html/Ip_Restricted_Simplified.html": 65012,
	"./eif/assets/html/Ip_Restricted_Traditional.html": 948,
	"./eif/assets/images/backgrounds/login_bg.png": 31723,
	"./eif/assets/images/logo/logo.ico": 70527,
	"./eif/assets/images/logo/logo_dark.png": 75062,
	"./eif/assets/images/logo/logo_dark.svg": 95460,
	"./eif/assets/images/logo/logo_light.png": 90248,
	"./eif/assets/images/logo/logo_light.svg": 90444,
	"./eif/assets/languages/cn.json": 28862,
	"./eif/assets/languages/en.json": 41316,
	"./eif/assets/languages/hk.json": 81586,
	"./eif/assets/languages/vi.json": 25174,
	"./eif/assets/styles/components/copy-right/copy-right.scss": 45566,
	"./eif/assets/styles/components/security-tips/security-tips.scss": 71280,
	"./eif/assets/styles/pages/bcan.scss": 81041,
	"./eif/assets/styles/pages/ipRestricted.scss": 38277,
	"./eif/components/Authentication/ImportantNotes/ImportantNotesDialog": 93124,
	"./eif/components/Authentication/ImportantNotes/ImportantNotesDialog.js": 93124,
	"./eif/components/Authentication/ResetPassword": 45982,
	"./eif/components/Authentication/ResetPassword/": 45982,
	"./eif/components/Authentication/ResetPassword/index": 45982,
	"./eif/components/Authentication/ResetPassword/index.js": 45982,
	"./eif/components/CopyRight/CopyRight": 49253,
	"./eif/components/CopyRight/CopyRight.js": 49253,
	"./eif/components/SecurityTips/SecurityTips": 1027,
	"./eif/components/SecurityTips/SecurityTips.js": 1027,
	"./eif/configurations/app-configs/config": 63001,
	"./eif/configurations/app-configs/config.js": 63001,
	"./eif/pages/Authentication/BCAN/BCAN": 85286,
	"./eif/pages/Authentication/BCAN/BCAN.js": 85286,
	"./eif/pages/Authentication/ipRestricted/ipRestricted": 22466,
	"./eif/pages/Authentication/ipRestricted/ipRestricted.js": 22466,
	"./fubon/assets/config": 76126,
	"./fubon/assets/config/": 76126,
	"./fubon/assets/config/index": 76126,
	"./fubon/assets/config/index.js": 76126,
	"./fubon/assets/images/backgrounds/login_bg.png": 49843,
	"./fubon/assets/images/icons/market-filter-active.png": 83369,
	"./fubon/assets/images/icons/market-filter.png": 20115,
	"./fubon/assets/images/icons/market_comment_add.png": 66201,
	"./fubon/assets/images/icons/market_comment_add_light.png": 79964,
	"./fubon/assets/images/icons/market_comment_picture.png": 59522,
	"./fubon/assets/images/icons/market_comment_picture_light.png": 39683,
	"./fubon/assets/images/icons/market_comment_post.png": 98724,
	"./fubon/assets/images/icons/market_comment_upload_failure.png": 87786,
	"./fubon/assets/images/icons/market_comment_upload_success.png": 24569,
	"./fubon/assets/images/icons/marketdetail_indicator_icon_blue.png": 77445,
	"./fubon/assets/images/icons/marketdetail_indicator_icon_light_blue.png": 37886,
	"./fubon/assets/images/icons/marketdetail_indicator_icon_orange.png": 29647,
	"./fubon/assets/images/icons/marketdetail_indicator_icon_red.png": 85800,
	"./fubon/assets/images/icons/marketdetail_indicator_icon_yellow.png": 65333,
	"./fubon/assets/images/logo/logo.ico": 29767,
	"./fubon/assets/images/logo/logo_dark.svg": 45704,
	"./fubon/assets/images/logo/logo_light.svg": 62408,
	"./fubon/assets/languages/cn.json": 47262,
	"./fubon/assets/languages/en.json": 47652,
	"./fubon/assets/languages/hk.json": 92530,
	"./fubon/assets/languages/vi.json": 29174,
	"./fubon/assets/styles/components/AssetsDetails.scss": 21534,
	"./fubon/assets/styles/components/Input.scss": 60583,
	"./fubon/assets/styles/components/VirtualTrading/VirtualTradingRightDetail/virtual-trading-area.scss": 20501,
	"./fubon/assets/styles/components/VirtualTrading/VirtualTradingRightDetail/virtual-trading-area/virtual-trading-area-bottom.scss": 36799,
	"./fubon/assets/styles/components/VirtualTrading/VirtualTradingRightDetail/virtual-trading-area/virtual-trading-area-left.scss": 51753,
	"./fubon/assets/styles/components/VirtualTrading/VirtualTradingRightDetail/virtual-trading-area/virtual-trading-area-right.scss": 94654,
	"./fubon/assets/styles/components/cash-account.scss": 59332,
	"./fubon/assets/styles/components/detail-center/chart.scss": 69337,
	"./fubon/assets/styles/components/detail-center/comment.scss": 65300,
	"./fubon/assets/styles/components/detail-center/comment_detail_dialog.scss": 769,
	"./fubon/assets/styles/components/detail-center/comment_detail_dialog_light.scss": 72234,
	"./fubon/assets/styles/components/detail-center/comment_light.scss": 80087,
	"./fubon/assets/styles/components/detail-center/comment_post_dialog.scss": 50948,
	"./fubon/assets/styles/components/detail-center/comment_post_dialog_light.scss": 85511,
	"./fubon/assets/styles/components/detail-center/comment_report_dialog.scss": 15868,
	"./fubon/assets/styles/components/detail-center/detail-center-light.scss": 80161,
	"./fubon/assets/styles/components/detail-center/detail-center.scss": 57124,
	"./fubon/assets/styles/components/detail-center/financials.scss": 88503,
	"./fubon/assets/styles/components/detail-center/financials_detail_dialog.scss": 55162,
	"./fubon/assets/styles/components/detail-center/financials_detail_dialog_light.scss": 59269,
	"./fubon/assets/styles/components/detail-center/financials_light.scss": 21768,
	"./fubon/assets/styles/components/detail-center/hnews.scss": 49462,
	"./fubon/assets/styles/components/detail-center/index-light.scss": 22652,
	"./fubon/assets/styles/components/detail-center/index.scss": 26073,
	"./fubon/assets/styles/components/detail-center/news.scss": 85612,
	"./fubon/assets/styles/components/detail-center/news_light.scss": 21839,
	"./fubon/assets/styles/components/detail-center/summary-light.scss": 19316,
	"./fubon/assets/styles/components/detail-center/summary.scss": 58033,
	"./fubon/assets/styles/components/detail-center/warrants.scss": 99445,
	"./fubon/assets/styles/components/instrument/bid-ask.scss": 97256,
	"./fubon/assets/styles/components/instrument/instrument.scss": 53432,
	"./fubon/assets/styles/components/instrument/place-order-option-light.scss": 87384,
	"./fubon/assets/styles/components/instrument/place-order-option.scss": 73605,
	"./fubon/assets/styles/components/market-detail-bottom-tab/market-detail-bottom-tab.scss": 35534,
	"./fubon/assets/styles/components/market/market-cn-light.scss": 59605,
	"./fubon/assets/styles/components/market/market-cn.scss": 1000,
	"./fubon/assets/styles/components/market/market-hk-light.scss": 44865,
	"./fubon/assets/styles/components/market/market-hk.scss": 50852,
	"./fubon/assets/styles/components/market/market-us-light.scss": 89700,
	"./fubon/assets/styles/components/market/market-us.scss": 63553,
	"./fubon/assets/styles/components/position-proportion/position-proportion-dialog-light.scss": 62494,
	"./fubon/assets/styles/components/position-proportion/position-proportion-dialog.scss": 60279,
	"./fubon/assets/styles/components/tab-header/tab-header.light.scss": 91622,
	"./fubon/assets/styles/components/tab-header/tab-header.scss": 13724,
	"./fubon/assets/styles/pages/market/market-page.light.scss": 99236,
	"./fubon/assets/styles/pages/market/market-page.scss": 85250,
	"./fubon/assets/styles/pages/my-account/my-account.scss": 25950,
	"./fubon/components/@app/CashAccount/AssetsDetails": 81676,
	"./fubon/components/@app/CashAccount/AssetsDetails.js": 81676,
	"./fubon/components/@app/CashAccount/CashAccount": 74299,
	"./fubon/components/@app/CashAccount/CashAccount.js": 74299,
	"./fubon/components/Authentication/ImportantNotes/ImportantNotesDialog": 25500,
	"./fubon/components/Authentication/ImportantNotes/ImportantNotesDialog.js": 25500,
	"./fubon/components/Authentication/Login/OTP": 67360,
	"./fubon/components/Authentication/Login/OTP.js": 67360,
	"./fubon/components/CopyRight/CopyRight": 53549,
	"./fubon/components/CopyRight/CopyRight.js": 53549,
	"./fubon/components/DetailCenter/DetailCenter": 17707,
	"./fubon/components/DetailCenter/DetailCenter.js": 17707,
	"./fubon/components/DetailCenter/DetailPage/Announcement": 53511,
	"./fubon/components/DetailCenter/DetailPage/Announcement.js": 53511,
	"./fubon/components/DetailCenter/DetailPage/Chart": 98630,
	"./fubon/components/DetailCenter/DetailPage/Chart.js": 98630,
	"./fubon/components/DetailCenter/DetailPage/Comment": 81163,
	"./fubon/components/DetailCenter/DetailPage/Comment.js": 81163,
	"./fubon/components/DetailCenter/DetailPage/CommentDetailDialog": 94370,
	"./fubon/components/DetailCenter/DetailPage/CommentDetailDialog.js": 94370,
	"./fubon/components/DetailCenter/DetailPage/CommentPostDialog": 92825,
	"./fubon/components/DetailCenter/DetailPage/CommentPostDialog.js": 92825,
	"./fubon/components/DetailCenter/DetailPage/CommentReportDialog": 91465,
	"./fubon/components/DetailCenter/DetailPage/CommentReportDialog.js": 91465,
	"./fubon/components/DetailCenter/DetailPage/Finances": 54131,
	"./fubon/components/DetailCenter/DetailPage/Finances.js": 54131,
	"./fubon/components/DetailCenter/DetailPage/Financials": 820,
	"./fubon/components/DetailCenter/DetailPage/Financials.js": 820,
	"./fubon/components/DetailCenter/DetailPage/FinancialsDetailDialog": 58481,
	"./fubon/components/DetailCenter/DetailPage/FinancialsDetailDialog.js": 58481,
	"./fubon/components/DetailCenter/DetailPage/HNews": 37045,
	"./fubon/components/DetailCenter/DetailPage/HNews.js": 37045,
	"./fubon/components/DetailCenter/DetailPage/Index": 37770,
	"./fubon/components/DetailCenter/DetailPage/Index.js": 37770,
	"./fubon/components/DetailCenter/DetailPage/News": 59391,
	"./fubon/components/DetailCenter/DetailPage/News.js": 59391,
	"./fubon/components/DetailCenter/DetailPage/Options": 86404,
	"./fubon/components/DetailCenter/DetailPage/Options.js": 86404,
	"./fubon/components/DetailCenter/DetailPage/OptionsTableFun": 43061,
	"./fubon/components/DetailCenter/DetailPage/OptionsTableFun.js": 43061,
	"./fubon/components/DetailCenter/DetailPage/Report": 54190,
	"./fubon/components/DetailCenter/DetailPage/Report.js": 54190,
	"./fubon/components/DetailCenter/DetailPage/Summary": 8374,
	"./fubon/components/DetailCenter/DetailPage/Summary.js": 8374,
	"./fubon/components/DetailCenter/DetailPage/Warrants": 96978,
	"./fubon/components/DetailCenter/DetailPage/Warrants.js": 96978,
	"./fubon/components/Input": 94093,
	"./fubon/components/Input/": 94093,
	"./fubon/components/Input/index": 94093,
	"./fubon/components/Input/index.js": 94093,
	"./fubon/components/Instrument/BidAsk": 58572,
	"./fubon/components/Instrument/BidAsk.js": 58572,
	"./fubon/components/Instrument/Instrument": 72573,
	"./fubon/components/Instrument/Instrument.js": 72573,
	"./fubon/components/Instrument/PlaceOrderOption": 33144,
	"./fubon/components/Instrument/PlaceOrderOption.js": 33144,
	"./fubon/components/Market/MarketInfo": 46119,
	"./fubon/components/Market/MarketInfo.js": 46119,
	"./fubon/components/Market/Market_CN": 41943,
	"./fubon/components/Market/Market_CN.js": 41943,
	"./fubon/components/Market/Market_HK": 29111,
	"./fubon/components/Market/Market_HK.js": 29111,
	"./fubon/components/Market/Market_US": 60302,
	"./fubon/components/Market/Market_US.js": 60302,
	"./fubon/components/MarketDetailBottomTab/MarketDetailBottomTab": 47941,
	"./fubon/components/MarketDetailBottomTab/MarketDetailBottomTab.js": 47941,
	"./fubon/components/MyAccount/AccountBalance/AccountBalance": 13435,
	"./fubon/components/MyAccount/AccountBalance/AccountBalance.js": 13435,
	"./fubon/components/MyAccount/AccountBalanceAction": 66753,
	"./fubon/components/MyAccount/AccountBalanceAction.js": 66753,
	"./fubon/components/MyAccount/CashAccountProfile/CashAccountProfile": 64771,
	"./fubon/components/MyAccount/CashAccountProfile/CashAccountProfile.js": 64771,
	"./fubon/components/MyAccount/Portfolio": 58892,
	"./fubon/components/MyAccount/Portfolio.js": 58892,
	"./fubon/components/MyAccount/Portfolio/Portfolio": 7879,
	"./fubon/components/MyAccount/Portfolio/Portfolio.js": 7879,
	"./fubon/components/MyAccount/PositionProportion/PositionProportion": 89867,
	"./fubon/components/MyAccount/PositionProportion/PositionProportion.js": 89867,
	"./fubon/components/MyAccount/PositionProportion/PositionProportionDialog": 6043,
	"./fubon/components/MyAccount/PositionProportion/PositionProportionDialog.js": 6043,
	"./fubon/components/MyAccount/PositionProportion/PositionProportionEChart": 44670,
	"./fubon/components/MyAccount/PositionProportion/PositionProportionEChart.js": 44670,
	"./fubon/components/OrderTable/OrderBook": 63618,
	"./fubon/components/OrderTable/OrderBook.js": 63618,
	"./fubon/components/OrderTable/OrderBook.mobile": 80532,
	"./fubon/components/OrderTable/OrderBook.mobile.js": 80532,
	"./fubon/components/OrderTable/OrderHistory": 2179,
	"./fubon/components/OrderTable/OrderHistory.js": 2179,
	"./fubon/components/OrderTable/OrderHistory.mobile": 86551,
	"./fubon/components/OrderTable/OrderHistory.mobile.js": 86551,
	"./fubon/components/PlaceOrder/PlaceOrderDialog": 50541,
	"./fubon/components/PlaceOrder/PlaceOrderDialog.js": 50541,
	"./fubon/components/TabHeader/TabHeader": 74886,
	"./fubon/components/TabHeader/TabHeader.js": 74886,
	"./fubon/components/VirtualTrading/VirtualTradingRightDetail/MyCompetition": 58078,
	"./fubon/components/VirtualTrading/VirtualTradingRightDetail/MyCompetition.js": 58078,
	"./fubon/components/VirtualTrading/VirtualTradingRightDetail/PersonalCenter": 43922,
	"./fubon/components/VirtualTrading/VirtualTradingRightDetail/PersonalCenter.js": 43922,
	"./fubon/components/VirtualTrading/VirtualTradingRightDetail/Ranking": 39797,
	"./fubon/components/VirtualTrading/VirtualTradingRightDetail/Ranking.js": 39797,
	"./fubon/components/VirtualTrading/VirtualTradingRightDetail/VirtualTradingArea": 30546,
	"./fubon/components/VirtualTrading/VirtualTradingRightDetail/VirtualTradingArea.js": 30546,
	"./fubon/components/VirtualTrading/VirtualTradingRightDetail/VirtualTradingArea/VirtualTradingAreaBottom": 10291,
	"./fubon/components/VirtualTrading/VirtualTradingRightDetail/VirtualTradingArea/VirtualTradingAreaBottom.js": 10291,
	"./fubon/components/VirtualTrading/VirtualTradingRightDetail/VirtualTradingArea/VirtualTradingAreaLeft": 79333,
	"./fubon/components/VirtualTrading/VirtualTradingRightDetail/VirtualTradingArea/VirtualTradingAreaLeft.js": 79333,
	"./fubon/components/VirtualTrading/VirtualTradingRightDetail/VirtualTradingArea/VirtualTradingAreaRight": 96068,
	"./fubon/components/VirtualTrading/VirtualTradingRightDetail/VirtualTradingArea/VirtualTradingAreaRight.js": 96068,
	"./fubon/components/Watchlist/Watchlist": 38269,
	"./fubon/components/Watchlist/Watchlist.js": 38269,
	"./fubon/components/Watchlist/WatchlistMinimize": 74637,
	"./fubon/components/Watchlist/WatchlistMinimize.js": 74637,
	"./fubon/components/Watchlist/Watchlistfilter": 1499,
	"./fubon/components/Watchlist/Watchlistfilter.js": 1499,
	"./fubon/configurations/app-configs/config": 60401,
	"./fubon/configurations/app-configs/config.js": 60401,
	"./fubon/pages/Market/Market": 73403,
	"./fubon/pages/Market/Market.js": 73403,
	"./fubon/pages/MyAccount/MyAccount": 18429,
	"./fubon/pages/MyAccount/MyAccount.js": 18429,
	"./fubon/pages/Trade/Trade": 30749,
	"./fubon/pages/Trade/Trade.js": 30749,
	"./fubon/pages/Trade/Trade.mobile": 70689,
	"./fubon/pages/Trade/Trade.mobile.js": 70689,
	"./scb/assets/aastock_libs/postmessage": 45524,
	"./scb/assets/aastock_libs/postmessage.js": 45524,
	"./scb/assets/config": 18650,
	"./scb/assets/config/": 18650,
	"./scb/assets/config/index": 18650,
	"./scb/assets/config/index.js": 18650,
	"./scb/assets/images/backgrounds/login_bg.png": 36207,
	"./scb/assets/images/logo/logo.ico": 32539,
	"./scb/assets/images/logo/logo.png": 38953,
	"./scb/assets/images/logo/logo_dark.svg": 89724,
	"./scb/assets/images/logo/logo_light.svg": 13364,
	"./scb/assets/languages/cn.json": 71806,
	"./scb/assets/languages/en.json": 55972,
	"./scb/assets/languages/hk.json": 17618,
	"./scb/assets/languages/vi.json": 23094,
	"./scb/assets/styles/components/apply-self-defined-user-id.scss": 71638,
	"./scb/assets/styles/components/copy-right/copy-right.scss": 39262,
	"./scb/assets/styles/components/dialog.scss": 25945,
	"./scb/assets/styles/components/disclaimer-dialog.scss": 63729,
	"./scb/assets/styles/components/e-message/e-message.light.scss": 67246,
	"./scb/assets/styles/components/e-message/e-message.scss": 5604,
	"./scb/assets/styles/components/instrument/instrument.scss": 15224,
	"./scb/assets/styles/components/instrument/place-order-option.scss": 29445,
	"./scb/assets/styles/components/ipo/application.scss": 65424,
	"./scb/assets/styles/components/ipo/apply.scss": 2866,
	"./scb/assets/styles/components/my-account/account-balance-one-row.scss": 5064,
	"./scb/assets/styles/components/my-account/my-account.scss": 34662,
	"./scb/assets/styles/components/order/order-audit.scss": 16210,
	"./scb/assets/styles/components/place-order-dialog.scss": 54080,
	"./scb/assets/styles/components/self-defined-user-id.scss": 73862,
	"./scb/assets/styles/components/tab-header/tab-header.scss": 20316,
	"./scb/assets/styles/components/tips.light.scss": 87133,
	"./scb/assets/styles/components/tips.scss": 76147,
	"./scb/assets/styles/pages/my-account/my-account.scss": 29214,
	"./scb/assets/styles/pages/trading-page.scss": 5146,
	"./scb/components/@app/IPO/AllotmentResultEnquiry": 2051,
	"./scb/components/@app/IPO/AllotmentResultEnquiry.js": 2051,
	"./scb/components/@app/IPO/Application": 11455,
	"./scb/components/@app/IPO/Application.js": 11455,
	"./scb/components/@app/IPO/ApplicationStatusEnquiry": 51944,
	"./scb/components/@app/IPO/ApplicationStatusEnquiry.js": 51944,
	"./scb/components/@app/IPO/Apply/Apply": 84114,
	"./scb/components/@app/IPO/Apply/Apply.js": 84114,
	"./scb/components/@app/IPO/Apply/Details": 27268,
	"./scb/components/@app/IPO/Apply/Details.js": 27268,
	"./scb/components/@app/IPO/Apply/Margin": 11202,
	"./scb/components/@app/IPO/Apply/Margin.js": 11202,
	"./scb/components/@app/IPO/Apply/Preview": 15602,
	"./scb/components/@app/IPO/Apply/Preview.js": 15602,
	"./scb/components/@app/IPO/Apply/Prospectus": 57164,
	"./scb/components/@app/IPO/Apply/Prospectus.js": 57164,
	"./scb/components/@app/IPO/Apply/Result": 21161,
	"./scb/components/@app/IPO/Apply/Result.js": 21161,
	"./scb/components/@app/IPO/Apply/Terms": 56909,
	"./scb/components/@app/IPO/Apply/Terms.js": 56909,
	"./scb/components/@app/IPO/ApplyPlan": 75874,
	"./scb/components/@app/IPO/ApplyPlan.js": 75874,
	"./scb/components/@app/IPO/ListedFocus": 6645,
	"./scb/components/@app/IPO/ListedFocus.js": 6645,
	"./scb/components/Authentication/ApplySelfDefinedUserID/ApplySelfDefinedUserIDDialog": 14124,
	"./scb/components/Authentication/ApplySelfDefinedUserID/ApplySelfDefinedUserIDDialog.js": 14124,
	"./scb/components/Authentication/ApplySelfDefinedUserID/ApplySelfDefinedUserIDForm": 31026,
	"./scb/components/Authentication/ApplySelfDefinedUserID/ApplySelfDefinedUserIDForm.js": 31026,
	"./scb/components/Authentication/ChangePassword/ChangePasswordDialog": 92524,
	"./scb/components/Authentication/ChangePassword/ChangePasswordDialog.js": 92524,
	"./scb/components/Authentication/ChangePassword/ChangePasswordForm": 966,
	"./scb/components/Authentication/ChangePassword/ChangePasswordForm.js": 966,
	"./scb/components/Authentication/ImportantNotes/ImportantNotesDialog": 21344,
	"./scb/components/Authentication/ImportantNotes/ImportantNotesDialog.js": 21344,
	"./scb/components/Authentication/SelfDefinedUserId/SelfDefinedUserId": 68724,
	"./scb/components/Authentication/SelfDefinedUserId/SelfDefinedUserId.js": 68724,
	"./scb/components/Authentication/SelfDefinedUserId/SelfDefinedUserIdDialog": 97352,
	"./scb/components/Authentication/SelfDefinedUserId/SelfDefinedUserIdDialog.js": 97352,
	"./scb/components/CashAccount/CashAccount": 15769,
	"./scb/components/CashAccount/CashAccount.js": 15769,
	"./scb/components/CopyRight/CopyRight": 42273,
	"./scb/components/CopyRight/CopyRight.js": 42273,
	"./scb/components/DataTable/CellRenderComponents/IPOCellRender": 22236,
	"./scb/components/DataTable/CellRenderComponents/IPOCellRender.js": 22236,
	"./scb/components/DataTable/CustomRenderer": 30343,
	"./scb/components/DataTable/CustomRenderer.js": 30343,
	"./scb/components/DataTable/DataTable": 42341,
	"./scb/components/DataTable/DataTable.js": 42341,
	"./scb/components/Dialog/Dialog": 4039,
	"./scb/components/Dialog/Dialog.js": 4039,
	"./scb/components/DisclaimerDialog/DisclaimerDialog": 81953,
	"./scb/components/DisclaimerDialog/DisclaimerDialog.js": 81953,
	"./scb/components/EMessage/EMessageDialog": 64627,
	"./scb/components/EMessage/EMessageDialog.js": 64627,
	"./scb/components/EMessage/EnquiryEMessage": 87986,
	"./scb/components/EMessage/EnquiryEMessage.js": 87986,
	"./scb/components/Input": 66513,
	"./scb/components/Input/": 66513,
	"./scb/components/Input/index": 66513,
	"./scb/components/Input/index.js": 66513,
	"./scb/components/Instrument/Instrument": 56913,
	"./scb/components/Instrument/Instrument.js": 56913,
	"./scb/components/Instrument/PlaceOrderOption": 22412,
	"./scb/components/Instrument/PlaceOrderOption.js": 22412,
	"./scb/components/Instrument/TriggerOrderMsgDialog": 28903,
	"./scb/components/Instrument/TriggerOrderMsgDialog.js": 28903,
	"./scb/components/MyAccount/AccountBalance/AccountBalanceOneRow": 71191,
	"./scb/components/MyAccount/AccountBalance/AccountBalanceOneRow.js": 71191,
	"./scb/components/MyAccount/Portfolio/Portfolio": 16379,
	"./scb/components/MyAccount/Portfolio/Portfolio.js": 16379,
	"./scb/components/OrderConfirm/OrderConfirm": 56735,
	"./scb/components/OrderConfirm/OrderConfirm.js": 56735,
	"./scb/components/OrderConfirm/OrderConfirmStatus": 94765,
	"./scb/components/OrderConfirm/OrderConfirmStatus.js": 94765,
	"./scb/components/OrderDialog/OrderAudit": 1598,
	"./scb/components/OrderDialog/OrderAudit.js": 1598,
	"./scb/components/OrderDialog/OrderCancel": 36231,
	"./scb/components/OrderDialog/OrderCancel.js": 36231,
	"./scb/components/OrderDialog/OrderFeesDialog": 74636,
	"./scb/components/OrderDialog/OrderFeesDialog.js": 74636,
	"./scb/components/OrderDialog/OrderInformation": 28827,
	"./scb/components/OrderDialog/OrderInformation.js": 28827,
	"./scb/components/OrderDialog/OrderJournalDetail": 8579,
	"./scb/components/OrderDialog/OrderJournalDetail.js": 8579,
	"./scb/components/OrderDialog/OrderModify": 17175,
	"./scb/components/OrderDialog/OrderModify.js": 17175,
	"./scb/components/OrderTable/OrderBook": 99942,
	"./scb/components/OrderTable/OrderBook.js": 99942,
	"./scb/components/OrderTable/OrderHistory": 99215,
	"./scb/components/OrderTable/OrderHistory.js": 99215,
	"./scb/components/PlaceOrder/PlaceOrderDialog": 36917,
	"./scb/components/PlaceOrder/PlaceOrderDialog.js": 36917,
	"./scb/components/TabHeader/TabHeader": 12477,
	"./scb/components/TabHeader/TabHeader.js": 12477,
	"./scb/components/Tips/Tips": 89019,
	"./scb/components/Tips/Tips.js": 89019,
	"./scb/configurations/app-configs/config": 28173,
	"./scb/configurations/app-configs/config.js": 28173,
	"./scb/constants/filter-type": 5098,
	"./scb/constants/filter-type.js": 5098,
	"./scb/helpers/functions": 38489,
	"./scb/helpers/functions/": 38489,
	"./scb/helpers/functions/comparatorFunctions": 72748,
	"./scb/helpers/functions/comparatorFunctions.js": 72748,
	"./scb/helpers/functions/converterFunctions": 21308,
	"./scb/helpers/functions/converterFunctions.js": 21308,
	"./scb/helpers/functions/filterFunctions": 77894,
	"./scb/helpers/functions/filterFunctions.js": 77894,
	"./scb/helpers/functions/formatFunction": 67934,
	"./scb/helpers/functions/formatFunction.js": 67934,
	"./scb/helpers/functions/gridFunctions": 78356,
	"./scb/helpers/functions/gridFunctions.js": 78356,
	"./scb/helpers/functions/index": 38489,
	"./scb/helpers/functions/index.js": 38489,
	"./scb/helpers/functions/utilsFunction": 15156,
	"./scb/helpers/functions/utilsFunction.js": 15156,
	"./scb/helpers/functions/validateFunction": 49691,
	"./scb/helpers/functions/validateFunction.js": 49691,
	"./scb/helpers/functions/websocket": 16638,
	"./scb/helpers/functions/websocket.js": 16638,
	"./scb/pages/Authentication/ChangePassword/ChangePassword": 28112,
	"./scb/pages/Authentication/ChangePassword/ChangePassword.js": 28112,
	"./scb/pages/EMessage/EMessage": 11451,
	"./scb/pages/EMessage/EMessage.js": 11451,
	"./scb/pages/IPO/IPO": 16621,
	"./scb/pages/IPO/IPO.js": 16621,
	"./scb/pages/MyAccount/MyAccount": 26065,
	"./scb/pages/MyAccount/MyAccount.js": 26065,
	"./scb/pages/Trade/Trade": 80689,
	"./scb/pages/Trade/Trade.js": 80689,
	"./ttl/assets/config": 11974,
	"./ttl/assets/config/": 11974,
	"./ttl/assets/config/index": 11974,
	"./ttl/assets/config/index.js": 11974,
	"./ttl/assets/files/funds.json": 10813,
	"./ttl/assets/images/backgrounds/login_bg.png": 28115,
	"./ttl/assets/images/icons/market-filter-active.png": 36489,
	"./ttl/assets/images/icons/market-filter.png": 4416,
	"./ttl/assets/images/icons/market_comment_add.png": 57977,
	"./ttl/assets/images/icons/market_comment_add_light.png": 41980,
	"./ttl/assets/images/icons/market_comment_picture.png": 10242,
	"./ttl/assets/images/icons/market_comment_picture_light.png": 78307,
	"./ttl/assets/images/icons/market_comment_post.png": 35556,
	"./ttl/assets/images/icons/market_comment_upload_failure.png": 8938,
	"./ttl/assets/images/icons/market_comment_upload_success.png": 11449,
	"./ttl/assets/images/icons/market_edit.png": 64864,
	"./ttl/assets/images/icons/market_set_top.png": 93206,
	"./ttl/assets/images/icons/marketdetail_indicator_icon_blue.png": 68389,
	"./ttl/assets/images/icons/marketdetail_indicator_icon_light_blue.png": 54942,
	"./ttl/assets/images/icons/marketdetail_indicator_icon_orange.png": 57519,
	"./ttl/assets/images/icons/marketdetail_indicator_icon_red.png": 19240,
	"./ttl/assets/images/icons/marketdetail_indicator_icon_yellow.png": 31733,
	"./ttl/assets/images/logo/logo.ico": 1159,
	"./ttl/assets/images/logo/logo.png": 87021,
	"./ttl/assets/images/logo/logo_dark.png": 81182,
	"./ttl/assets/images/logo/logo_dark.svg": 7540,
	"./ttl/assets/images/logo/logo_light.png": 22848,
	"./ttl/assets/images/logo/logo_light.svg": 92092,
	"./ttl/assets/languages/cn.json": 5906,
	"./ttl/assets/languages/en.json": 93776,
	"./ttl/assets/languages/hk.json": 70862,
	"./ttl/assets/languages/vi.json": 43450,
	"./ttl/assets/styles/components/AssetsDetails.scss": 59322,
	"./ttl/assets/styles/components/Input.scss": 63131,
	"./ttl/assets/styles/components/VirtualTrading/VirtualTradingRightDetail/virtual-trading-area.scss": 22601,
	"./ttl/assets/styles/components/VirtualTrading/VirtualTradingRightDetail/virtual-trading-area/virtual-trading-area-bottom.scss": 43603,
	"./ttl/assets/styles/components/cash-account-mobile.scss": 29109,
	"./ttl/assets/styles/components/cash-account.scss": 67440,
	"./ttl/assets/styles/components/detail-center.mobile/comment.mobile.scss": 59648,
	"./ttl/assets/styles/components/detail-center.mobile/detail-center.mobile.scss": 4176,
	"./ttl/assets/styles/components/detail-center/chart.scss": 94605,
	"./ttl/assets/styles/components/detail-center/comment.scss": 81936,
	"./ttl/assets/styles/components/detail-center/comment_detail_dialog.scss": 91821,
	"./ttl/assets/styles/components/detail-center/comment_detail_dialog_light.scss": 16598,
	"./ttl/assets/styles/components/detail-center/comment_light.scss": 8851,
	"./ttl/assets/styles/components/detail-center/comment_post_dialog.scss": 4240,
	"./ttl/assets/styles/components/detail-center/comment_post_dialog_light.scss": 72083,
	"./ttl/assets/styles/components/detail-center/comment_report_dialog.scss": 66176,
	"./ttl/assets/styles/components/detail-center/detail-center-light.scss": 56149,
	"./ttl/assets/styles/components/detail-center/detail-center.scss": 84136,
	"./ttl/assets/styles/components/detail-center/financials.scss": 62923,
	"./ttl/assets/styles/components/detail-center/financials_detail_dialog.scss": 36558,
	"./ttl/assets/styles/components/detail-center/financials_detail_dialog_light.scss": 82953,
	"./ttl/assets/styles/components/detail-center/financials_light.scss": 61004,
	"./ttl/assets/styles/components/detail-center/hnews.scss": 84714,
	"./ttl/assets/styles/components/detail-center/index-light.scss": 75968,
	"./ttl/assets/styles/components/detail-center/index.scss": 90061,
	"./ttl/assets/styles/components/detail-center/news.scss": 74424,
	"./ttl/assets/styles/components/detail-center/news_light.scss": 84955,
	"./ttl/assets/styles/components/detail-center/options.scss": 20795,
	"./ttl/assets/styles/components/detail-center/options_table_fun.scss": 11450,
	"./ttl/assets/styles/components/detail-center/options_table_fun_light.scss": 97285,
	"./ttl/assets/styles/components/detail-center/summary-light.scss": 3288,
	"./ttl/assets/styles/components/detail-center/summary.scss": 30885,
	"./ttl/assets/styles/components/detail-center/warrants.scss": 30673,
	"./ttl/assets/styles/components/instrument/bid-ask.scss": 56028,
	"./ttl/assets/styles/components/instrument/historical-mobile.scss": 84410,
	"./ttl/assets/styles/components/instrument/instrument.scss": 49260,
	"./ttl/assets/styles/components/instrument/manage-wathlist-group-mobile.scss": 31824,
	"./ttl/assets/styles/components/instrument/market-add-group-dialog-mobile.scss": 7141,
	"./ttl/assets/styles/components/instrument/market-add-watchlist-dialog.scss": 5200,
	"./ttl/assets/styles/components/instrument/market-set-confirm-dialog.scss": 50688,
	"./ttl/assets/styles/components/instrument/market-set-dialog-light.scss": 34910,
	"./ttl/assets/styles/components/instrument/market-set-dialog.scss": 80855,
	"./ttl/assets/styles/components/instrument/market-set-mobile.scss": 62121,
	"./ttl/assets/styles/components/instrument/place-order-option-light.scss": 27356,
	"./ttl/assets/styles/components/instrument/place-order-option.scss": 95449,
	"./ttl/assets/styles/components/market-detail-bottom-tab/market-detail-bottom-tab.scss": 30978,
	"./ttl/assets/styles/components/market/market-cn-light.scss": 34145,
	"./ttl/assets/styles/components/market/market-cn.scss": 69348,
	"./ttl/assets/styles/components/market/market-funds.scss": 52912,
	"./ttl/assets/styles/components/market/market-hk-light.scss": 49893,
	"./ttl/assets/styles/components/market/market-hk.scss": 14904,
	"./ttl/assets/styles/components/market/market-us-light.scss": 71808,
	"./ttl/assets/styles/components/market/market-us.scss": 13261,
	"./ttl/assets/styles/components/my-account/cash-account-profile-mobile.scss": 18244,
	"./ttl/assets/styles/components/order/order-book.scss": 76054,
	"./ttl/assets/styles/components/order/order-cancel.scss": 74685,
	"./ttl/assets/styles/components/order/order-history.scss": 3913,
	"./ttl/assets/styles/components/order/order-journal-detail.scss": 29064,
	"./ttl/assets/styles/components/position-proportion/position-proportion-dialog-light.scss": 61522,
	"./ttl/assets/styles/components/position-proportion/position-proportion-dialog.scss": 29739,
	"./ttl/assets/styles/components/position-proportion/position-proportion-mobile.scss": 95997,
	"./ttl/assets/styles/components/tab-header/tab-header.light.scss": 57418,
	"./ttl/assets/styles/components/tab-header/tab-header.scss": 95552,
	"./ttl/assets/styles/pages/market/market-page-mobile.scss": 66495,
	"./ttl/assets/styles/pages/market/market-page.light.scss": 8472,
	"./ttl/assets/styles/pages/market/market-page.scss": 55878,
	"./ttl/assets/styles/pages/my-account/my-account-mobile.scss": 88363,
	"./ttl/assets/styles/pages/my-account/my-account.scss": 67810,
	"./ttl/assets/styles/pages/trade-mobile.scss": 73682,
	"./ttl/components/@app/CashAccount/AssetsDetails": 71300,
	"./ttl/components/@app/CashAccount/AssetsDetails.js": 71300,
	"./ttl/components/@app/CashAccount/CashAccount": 37091,
	"./ttl/components/@app/CashAccount/CashAccount.js": 37091,
	"./ttl/components/@app/CashAccount/CashAccount.mobile": 38295,
	"./ttl/components/@app/CashAccount/CashAccount.mobile.js": 38295,
	"./ttl/components/Authentication/ImportantNotes/ImportantNotesDialog": 88916,
	"./ttl/components/Authentication/ImportantNotes/ImportantNotesDialog.js": 88916,
	"./ttl/components/Authentication/Login/OTP": 53464,
	"./ttl/components/Authentication/Login/OTP.js": 53464,
	"./ttl/components/CopyRight/CopyRight": 86901,
	"./ttl/components/CopyRight/CopyRight.js": 86901,
	"./ttl/components/DetailCenter/DetailCenter": 13363,
	"./ttl/components/DetailCenter/DetailCenter.js": 13363,
	"./ttl/components/DetailCenter/DetailCenter.mobile": 76871,
	"./ttl/components/DetailCenter/DetailCenter.mobile.js": 76871,
	"./ttl/components/DetailCenter/DetailPage.mobile/Comment.mobile": 93619,
	"./ttl/components/DetailCenter/DetailPage.mobile/Comment.mobile.js": 93619,
	"./ttl/components/DetailCenter/DetailPage.mobile/Quote.mobile": 28380,
	"./ttl/components/DetailCenter/DetailPage.mobile/Quote.mobile.js": 28380,
	"./ttl/components/DetailCenter/DetailPage/Announcement": 7647,
	"./ttl/components/DetailCenter/DetailPage/Announcement.js": 7647,
	"./ttl/components/DetailCenter/DetailPage/Chart": 24126,
	"./ttl/components/DetailCenter/DetailPage/Chart.js": 24126,
	"./ttl/components/DetailCenter/DetailPage/Comment": 34899,
	"./ttl/components/DetailCenter/DetailPage/Comment.js": 34899,
	"./ttl/components/DetailCenter/DetailPage/CommentDetailDialog": 71930,
	"./ttl/components/DetailCenter/DetailPage/CommentDetailDialog.js": 71930,
	"./ttl/components/DetailCenter/DetailPage/CommentPostDialog": 25761,
	"./ttl/components/DetailCenter/DetailPage/CommentPostDialog.js": 25761,
	"./ttl/components/DetailCenter/DetailPage/CommentReportDialog": 18609,
	"./ttl/components/DetailCenter/DetailPage/CommentReportDialog.js": 18609,
	"./ttl/components/DetailCenter/DetailPage/Finances": 42523,
	"./ttl/components/DetailCenter/DetailPage/Finances.js": 42523,
	"./ttl/components/DetailCenter/DetailPage/Financials": 89500,
	"./ttl/components/DetailCenter/DetailPage/Financials.js": 89500,
	"./ttl/components/DetailCenter/DetailPage/FinancialsDetailDialog": 49961,
	"./ttl/components/DetailCenter/DetailPage/FinancialsDetailDialog.js": 49961,
	"./ttl/components/DetailCenter/DetailPage/HNews": 29917,
	"./ttl/components/DetailCenter/DetailPage/HNews.js": 29917,
	"./ttl/components/DetailCenter/DetailPage/Index": 36962,
	"./ttl/components/DetailCenter/DetailPage/Index.js": 36962,
	"./ttl/components/DetailCenter/DetailPage/News": 7559,
	"./ttl/components/DetailCenter/DetailPage/News.js": 7559,
	"./ttl/components/DetailCenter/DetailPage/Options": 68524,
	"./ttl/components/DetailCenter/DetailPage/Options.js": 68524,
	"./ttl/components/DetailCenter/DetailPage/OptionsTableFun": 48061,
	"./ttl/components/DetailCenter/DetailPage/OptionsTableFun.js": 48061,
	"./ttl/components/DetailCenter/DetailPage/Report": 73750,
	"./ttl/components/DetailCenter/DetailPage/Report.js": 73750,
	"./ttl/components/DetailCenter/DetailPage/Summary": 14222,
	"./ttl/components/DetailCenter/DetailPage/Summary.js": 14222,
	"./ttl/components/DetailCenter/DetailPage/Warrants": 63866,
	"./ttl/components/DetailCenter/DetailPage/Warrants.js": 63866,
	"./ttl/components/FundManagement/ExchangeInstruction.mobile": 3762,
	"./ttl/components/FundManagement/ExchangeInstruction.mobile.js": 3762,
	"./ttl/components/FundManagement/FundManagementWithdrawal.mobile": 93254,
	"./ttl/components/FundManagement/FundManagementWithdrawal.mobile.js": 93254,
	"./ttl/components/Input": 45061,
	"./ttl/components/Input/": 45061,
	"./ttl/components/Input/index": 45061,
	"./ttl/components/Input/index.js": 45061,
	"./ttl/components/Instrument/BidAsk": 47220,
	"./ttl/components/Instrument/BidAsk.js": 47220,
	"./ttl/components/Instrument/FundHistorical.mobile": 86039,
	"./ttl/components/Instrument/FundHistorical.mobile.js": 86039,
	"./ttl/components/Instrument/Instrument": 39973,
	"./ttl/components/Instrument/Instrument.js": 39973,
	"./ttl/components/Instrument/Instrument.mobile": 41038,
	"./ttl/components/Instrument/Instrument.mobile.js": 41038,
	"./ttl/components/Instrument/ManageWatchlistGroup.mobile": 19705,
	"./ttl/components/Instrument/ManageWatchlistGroup.mobile.js": 19705,
	"./ttl/components/Instrument/MarketAddGroupDialog.mobile": 89152,
	"./ttl/components/Instrument/MarketAddGroupDialog.mobile.js": 89152,
	"./ttl/components/Instrument/MarketAddWatchlistDialog": 366,
	"./ttl/components/Instrument/MarketAddWatchlistDialog.js": 366,
	"./ttl/components/Instrument/MarketSet.mobile": 35451,
	"./ttl/components/Instrument/MarketSet.mobile.js": 35451,
	"./ttl/components/Instrument/MarketSetDialog": 59382,
	"./ttl/components/Instrument/MarketSetDialog.js": 59382,
	"./ttl/components/Instrument/MarketSetconfirmDialog": 66276,
	"./ttl/components/Instrument/MarketSetconfirmDialog.js": 66276,
	"./ttl/components/Instrument/PlaceOrderOption": 94752,
	"./ttl/components/Instrument/PlaceOrderOption.js": 94752,
	"./ttl/components/Market/MarketFunds": 55159,
	"./ttl/components/Market/MarketFunds.js": 55159,
	"./ttl/components/Market/MarketIndex.mobile": 12755,
	"./ttl/components/Market/MarketIndex.mobile.js": 12755,
	"./ttl/components/Market/MarketInfo": 73599,
	"./ttl/components/Market/MarketInfo.js": 73599,
	"./ttl/components/Market/MarketInfo.mobile": 77235,
	"./ttl/components/Market/MarketInfo.mobile.js": 77235,
	"./ttl/components/Market/Market_CN": 13903,
	"./ttl/components/Market/Market_CN.js": 13903,
	"./ttl/components/Market/Market_CN.mobile": 23299,
	"./ttl/components/Market/Market_CN.mobile.js": 23299,
	"./ttl/components/Market/Market_HK": 52511,
	"./ttl/components/Market/Market_HK.js": 52511,
	"./ttl/components/Market/Market_HK.mobile": 34803,
	"./ttl/components/Market/Market_HK.mobile.js": 34803,
	"./ttl/components/Market/Market_US": 64150,
	"./ttl/components/Market/Market_US.js": 64150,
	"./ttl/components/MarketDetailBottomTab/MarketDetailBottomTab": 75853,
	"./ttl/components/MarketDetailBottomTab/MarketDetailBottomTab.js": 75853,
	"./ttl/components/MyAccount/AccountBalance/AccountBalance": 89971,
	"./ttl/components/MyAccount/AccountBalance/AccountBalance.js": 89971,
	"./ttl/components/MyAccount/AccountBalanceAction": 43497,
	"./ttl/components/MyAccount/AccountBalanceAction.js": 43497,
	"./ttl/components/MyAccount/CashAccountProfile/CashAccountAccountProfileMobile": 31438,
	"./ttl/components/MyAccount/CashAccountProfile/CashAccountAccountProfileMobile.js": 31438,
	"./ttl/components/MyAccount/CashAccountProfile/CashAccountProfile": 60648,
	"./ttl/components/MyAccount/CashAccountProfile/CashAccountProfile.js": 60648,
	"./ttl/components/MyAccount/Portfolio": 59204,
	"./ttl/components/MyAccount/Portfolio.js": 59204,
	"./ttl/components/MyAccount/Portfolio/Portfolio": 89855,
	"./ttl/components/MyAccount/Portfolio/Portfolio.js": 89855,
	"./ttl/components/MyAccount/Portfolio/Portfolio.mobile": 41395,
	"./ttl/components/MyAccount/Portfolio/Portfolio.mobile.js": 41395,
	"./ttl/components/MyAccount/PositionProportion/PositionProportion": 7875,
	"./ttl/components/MyAccount/PositionProportion/PositionProportion.js": 7875,
	"./ttl/components/MyAccount/PositionProportion/PositionProportionDialog": 675,
	"./ttl/components/MyAccount/PositionProportion/PositionProportionDialog.js": 675,
	"./ttl/components/MyAccount/PositionProportion/PositionProportionDialog.mobile": 87191,
	"./ttl/components/MyAccount/PositionProportion/PositionProportionDialog.mobile.js": 87191,
	"./ttl/components/MyAccount/PositionProportion/PositionProportionEChart": 56838,
	"./ttl/components/MyAccount/PositionProportion/PositionProportionEChart.js": 56838,
	"./ttl/components/MyAccount/PositionProportion/PositionProportionMobile": 72753,
	"./ttl/components/MyAccount/PositionProportion/PositionProportionMobile.js": 72753,
	"./ttl/components/OrderCancel/OrderCancel.mobile": 59745,
	"./ttl/components/OrderCancel/OrderCancel.mobile.js": 59745,
	"./ttl/components/OrderConfirm/OrderConfirm": 69699,
	"./ttl/components/OrderConfirm/OrderConfirm.js": 69699,
	"./ttl/components/OrderConfirm/OrderConfirm.mobile": 15127,
	"./ttl/components/OrderConfirm/OrderConfirm.mobile.js": 15127,
	"./ttl/components/OrderConfirm/OrderConfirmStatus": 97913,
	"./ttl/components/OrderConfirm/OrderConfirmStatus.js": 97913,
	"./ttl/components/OrderConfirm/OrderConfirmStatus.mobile": 81245,
	"./ttl/components/OrderConfirm/OrderConfirmStatus.mobile.js": 81245,
	"./ttl/components/OrderDialog/OrderAudit": 84450,
	"./ttl/components/OrderDialog/OrderAudit.js": 84450,
	"./ttl/components/OrderDialog/OrderCancel": 77939,
	"./ttl/components/OrderDialog/OrderCancel.js": 77939,
	"./ttl/components/OrderDialog/OrderFeesDialog": 35384,
	"./ttl/components/OrderDialog/OrderFeesDialog.js": 35384,
	"./ttl/components/OrderDialog/OrderInformation": 5999,
	"./ttl/components/OrderDialog/OrderInformation.js": 5999,
	"./ttl/components/OrderDialog/OrderJournalDetail": 49919,
	"./ttl/components/OrderDialog/OrderJournalDetail.js": 49919,
	"./ttl/components/OrderDialog/OrderModify": 86683,
	"./ttl/components/OrderDialog/OrderModify.js": 86683,
	"./ttl/components/OrderJournalDetail/OrderJournalDetail.mobile": 26995,
	"./ttl/components/OrderJournalDetail/OrderJournalDetail.mobile.js": 26995,
	"./ttl/components/OrderTable/OrderBook": 24570,
	"./ttl/components/OrderTable/OrderBook.js": 24570,
	"./ttl/components/OrderTable/OrderBook.mobile": 81132,
	"./ttl/components/OrderTable/OrderBook.mobile.js": 81132,
	"./ttl/components/OrderTable/OrderHistory": 9499,
	"./ttl/components/OrderTable/OrderHistory.js": 9499,
	"./ttl/components/OrderTable/OrderHistory.mobile": 83407,
	"./ttl/components/OrderTable/OrderHistory.mobile.js": 83407,
	"./ttl/components/PlaceOrder/PlaceOrderDialog": 31717,
	"./ttl/components/PlaceOrder/PlaceOrderDialog.js": 31717,
	"./ttl/components/TabHeader/TabHeader": 79565,
	"./ttl/components/TabHeader/TabHeader.js": 79565,
	"./ttl/components/Watchlist/Watchlist": 63589,
	"./ttl/components/Watchlist/Watchlist.js": 63589,
	"./ttl/components/Watchlist/Watchlist.mobile": 68329,
	"./ttl/components/Watchlist/Watchlist.mobile.js": 68329,
	"./ttl/components/Watchlist/WatchlistMinimize": 59717,
	"./ttl/components/Watchlist/WatchlistMinimize.js": 59717,
	"./ttl/components/Watchlist/Watchlistfilter": 84451,
	"./ttl/components/Watchlist/Watchlistfilter.js": 84451,
	"./ttl/configurations/app-configs/config": 43753,
	"./ttl/configurations/app-configs/config.js": 43753,
	"./ttl/pages/Market/Market": 79619,
	"./ttl/pages/Market/Market.js": 79619,
	"./ttl/pages/Market/Market.mobile": 98551,
	"./ttl/pages/Market/Market.mobile.js": 98551,
	"./ttl/pages/MyAccount/MyAccount": 77413,
	"./ttl/pages/MyAccount/MyAccount.js": 77413,
	"./ttl/pages/MyAccount/MyAccount.mobile": 41609,
	"./ttl/pages/MyAccount/MyAccount.mobile.js": 41609,
	"./ttl/pages/PlaceOrder/PlaceOrder.mobile": 99409,
	"./ttl/pages/PlaceOrder/PlaceOrder.mobile.js": 99409,
	"./ttl/pages/Trade/Trade": 22405,
	"./ttl/pages/Trade/Trade.js": 22405,
	"./ttl/pages/Trade/Trade.mobile": 36009,
	"./ttl/pages/Trade/Trade.mobile.js": 36009
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53913;